import React, { createContext, PropsWithChildren } from 'react';
import { AccountCreateContextProps } from '@components-member/TradingAccounts/AccountCreate/context/interfaces';

export const AccountCreateContext = createContext<AccountCreateContextProps>({} as never);

export const AccountCreateContextProvider = ({
  openAccountType,
  isAccountLimitForUnverifiedUsers,
  formOpeningSource,
  children,
  accountCreateState,
  availablePlatform,
  selectedPlatformType,
  contestId,
  setSelectedPlatformType,
  refresh,
  updateActionState,
}: PropsWithChildren<AccountCreateContextProps>): JSX.Element => {
  const providerValue = {
    isAccountLimitForUnverifiedUsers,
    formOpeningSource,
    openAccountType,
    accountCreateState,
    availablePlatform,
    selectedPlatformType,
    contestId,
    setSelectedPlatformType,
    updateActionState,
    refresh,
  };

  return <AccountCreateContext.Provider value={providerValue}>{children}</AccountCreateContext.Provider>;
};
